export { default as AvatarEmoji } from './AvatarEmoji'
